import moment from 'moment';
export default function dateFormatView(paramFormName, paramDateTime) {
  let formatDateTime = '';
  if (!paramFormName[paramDateTime] || paramFormName[paramDateTime].indexOf('0001-01-01') > -1) {
    formatDateTime = '';
  } else {
    formatDateTime = moment(paramFormName[paramDateTime]).format('YYYY/MM/DD');
  }
  return formatDateTime;
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/utils/dateFormatView.js
 **/